import classNames from 'classnames';
import React, { useState } from 'react';

import { Icon, IconArrowDownL, IconArrowUpL } from '@flixbus/honeycomb-icons-react';
import { Dropdown, DropdownItem } from '@flixbus/honeycomb-react';

import { TIME_ZONES_ADDITIONS, TIME_ZONES_STANDARD } from 'utils/datetime';

import styles from './styles.module.css';

const TZ_ARRAY_STANDARD = Object.values(TIME_ZONES_STANDARD);

const TimezoneSelector = ({ selected, additionalOptions = [], onSelection = () => {} }) => {
	const [arrowUp, setArrowUp] = useState(false);
	const [hideDropdown, setHideDropdown] = useState(false);

	const toggleArrowButton = (isActive) => {
		setArrowUp(isActive);
		if (isActive) {
			setHideDropdown(false);
		}
	};

	const topList = [...additionalOptions, TIME_ZONES_ADDITIONS.myTime];

	const handleSelection = (e, timezone) => {
		e.preventDefault();
		onSelection(timezone);
		setHideDropdown(true);
	};

	const linkArray = [
		...topList.map((elem) => (
			<DropdownItem
				Elem="a"
				active={elem.name === selected.name}
				href=""
				onClick={(e) => handleSelection(e, elem)}
				key={`${elem.value}${elem.name}`}
			>
				{elem.name}
			</DropdownItem>
		)),
		<DropdownItem key="divider" divider />,
		...TZ_ARRAY_STANDARD.map((elem) => (
			<DropdownItem
				Elem="a"
				href=""
				active={elem.name === selected.name}
				onClick={(e) => handleSelection(e, elem)}
				key={elem.value}
			>
				{elem.name}
			</DropdownItem>
		)),
	];

	return (
		<Dropdown
			links={linkArray}
			onToggle={toggleArrowButton}
			yPosition="bottom"
			xPosition="left"
			extraClasses={classNames({
				[styles.hideDropdown]: hideDropdown,
			})}
		>
			<div className={styles.spaced}>
				<div className={styles.text}>
					<div className={styles.contain}>{selected.name}</div>
				</div>
				<Icon
					extraClasses={styles.icon}
					InlineIcon={arrowUp ? IconArrowUpL : IconArrowDownL}
					size={3}
				/>
			</div>
		</Dropdown>
	);
};

export default TimezoneSelector;
